import { render, staticRenderFns } from "./AuthSidebarBottom.vue?vue&type=template&id=230df1ff&scoped=true&"
import script from "./AuthSidebarBottom.vue?vue&type=script&lang=ts&"
export * from "./AuthSidebarBottom.vue?vue&type=script&lang=ts&"
import style0 from "./AuthSidebarBottom.vue?vue&type=style&index=0&id=230df1ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230df1ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
